import { render, staticRenderFns } from "./remindersList.vue?vue&type=template&id=1297905a&scoped=true"
import script from "./remindersList.vue?vue&type=script&lang=js"
export * from "./remindersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1297905a",
  null
  
)

export default component.exports